import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { JsonDataService } from 'src/app/services/json-data.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { HttpClient } from '@angular/common/http';
@Component({
    selector: 'partners-series-notification-maintenance',
    templateUrl: './partners-series-notification-maintenance.component.html',
    styleUrls: ['./partners-series-notification-maintenance.component.css']
})
export class PartnersSeriesNotificationMaintenanceComponent implements OnInit {

    private readonly redirectUrl = 'https://pap.dev.bpimsapps.com/#/login';

    userId: string = this.userDetailService.userId;
    moduleId: string = 'BMZ015';
    moduleName = this.jsonDataService.data.moduleList
        .filter((data: any) => data.moduleId === this.moduleId)[0]
        ?.moduleDesc ?? 'Series Notification Maintenance';

    constructor(
      private jsonDataService: JsonDataService,
      private userDetailService: UserDetailsService,
      private http: HttpClient
    ) {}

    datePipe = new DatePipe('en-us');

    ngOnInit(): void {}

    getRedirectUrl(): string {
        const hostname = window.location.hostname;

        if (hostname === 'admin.osp-devt.com') {
            return 'https://partners-api-v2.dev.bpimsapps.com/coic/session/redirect';
        } else if (hostname === 'admin.osp-test.com') {
            return 'https://partners-api-v2.uat.bpimsapps.com/coic/session/redirect';
        } else if (hostname === 'admin.express-protect.com') {
            return 'https://partners-api-v2.bpimsapps.com/coic/session/redirect';
        } else {
            console.error('Unknown hostname:', hostname);
            return '';
        }
    }

    getPartnersRedirectModule() : string {
      return 'sequence-alert'
    }

    buildPayload() {
        const currentDate = new Date();
        const formattedDate = this.datePipe.transform(currentDate, 'yyyy-MM-dd HH:mm:ss');

        return {
            time: formattedDate,
            name: this.userDetailService.name,
            userId: this.userDetailService.userId,
            email: this.userDetailService.email,
            moduleId: this.moduleId,
            moduleName: 'test',
        };
    }

    onButtonClick(): void {
        // window.open(this.redirectUrl, '_blank');

        const url = this.getRedirectUrl();
        const payload = this.buildPayload();

        if (!url) return;
        this.jsonDataService.contorlLoading(true);
        const encryptedData = this.jsonDataService.encrypt(
            JSON.stringify(payload)
        );

        this.http.post(url, JSON.stringify({ data: encryptedData}), {
            observe: 'response'
        }).subscribe({
            next: (res: any) => {

                try {
                    const encrypted = res.body?.data;

                    if (!encrypted) {
                        console.warn('No encrypted data found');
                        return;
                    }
                    const decrypted = this.jsonDataService.decrypt(encrypted);
                    console.log('Decrypted:', decrypted);
                    const parsed = JSON.parse(decrypted);
                    console.log('Parsed:', parsed);
                    this.jsonDataService.contorlLoading(false);
                    if (parsed?.redirectUrl) {
                        let redirectUrl = parsed.redirectUrl
                        redirectUrl += `&redirect=${this.getPartnersRedirectModule()}`
                        window.open(redirectUrl, '_blank');
                    }

                } catch (err) {
                    console.error('Decryption/Parsing error:', err);
                }
            },
            error: (err) => {
                console.error('Redirect error:', err);
            }
        });
    }
}
